<template>
  <div class="pro-body">
    <div class="pro-item" v-for="(item, index) in ordergoods">
      <van-row>
        <van-checkbox-group v-model="result" @change="getresult">
          <van-cell-group>
            <van-col span="24">
              <h5>
                <span>
                  <van-checkbox :name="item.goodsId">商品名称</van-checkbox>
                </span>
                <span v-if="data.orders.reservedOrderFlag>0" style="color:red;">预售</span>
                <!-- {{item.goods_name}} -->
                <span v-if="item.parent_cart_id!=null" style="color: red">(赠)</span>
              </h5>
            </van-col>
          </van-cell-group>
        </van-checkbox-group>
      </van-row>
      <van-row class="pro-item-by">
        <!-- <van-col span="12">
                     <p>使用价目表价格</p>
                 </van-col>
                 <van-col span="12" class="text-right">
                     <van-switch v-model="checked" @change="priceswitch"/>
        </van-col>-->
      </van-row>
      <van-row>
        <van-col span="8">
          <p>
            <span>订货数量</span>
            {{item.count}}
          </p>
        </van-col>
        <van-col span="8" class="text-center">
          <p>
            <span>赠送数量</span>
            {{item.give_count}}
          </p>
        </van-col>
        <van-col span="8" class="text-right">
          <p>
            <span>发运数量</span>
            {{item.shipment_count}}
          </p>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="12">
          <p>
            <span>商品单价</span>
            {{item.price}}
          </p>
          <!-- <p v-if="item.discount">
                         <span>商品单价</span>{{item.price * item.discount}}
                     </p>
                     <p v-else-if="item.pay_discount">
                         <span>商品单价</span>{{item.price * item.pay_discount}}
                     </p>
                     <p v-else>
                         <span>商品单价</span>{{item.price}}
          </p>-->
        </van-col>
        <van-col span="12" class="text-right">
          <p>
            <span>价目表单价</span>
            {{jmbjg[index]}}
          </p>
        </van-col>
        <van-col span="24" v-if="workFlow.workflowType==4 || data.isBmDealTwo || data.isTmDealTwo">
          <p
            v-if="data.flag && (data.isTmSedNotinAudit || data.isBmDealTwo || data.isTmDealTwo)&&actionStatus=='false'"
          >
            <van-field
              v-model="receivedCount[index]"
              label="到货数量"
              placeholder="请输入到货数量"
              @blur="getreceivedCount"
            />
          </p>
          <p v-else>
            <van-field v-model="item.receivedCount" label="到货数量" readonly placeholder="请输入到货数量" />
          </p>
        </van-col>
        <!-- 超市类商品并且为主商品 -->
        <van-row v-if="item.parent_cart_id==null">
          <van-col span="24" v-if="workFlow.workflowType==2">
            <van-cell title="查看库存" value is-link @click="showKuCun(item)" />
          </van-col>

          <van-col span="24" v-if="workFlow.workflowType==3">
            <van-cell title="查看库存" value is-link @click="showKuCunC(item)" />
          </van-col>
        </van-row>
        <van-row v-else>
          <van-col span="12">
            <p>
              <span>规则ID</span>
              {{item.GiftSurplusInfos[0].ruleId}}
            </p>
          </van-col>
          <van-col span="12" class="text-right">
            <p>
              <span>总量</span>
              {{item.GiftSurplusInfos[0].giftCount}}
            </p>
          </van-col>
          <van-col span="12">
            <p>
              <span>余量</span>
              {{item.GiftSurplusInfos[0].giftSurplusCount}}
            </p>
          </van-col>
        </van-row>
      </van-row>
      <van-row class="pro-item-ft">
        <van-col span="24">
          <van-field
            v-model="goodcode[index]"
            readonly
            label="出库编码"
            placeholder="请选择出库编码"
            @focus="goodcodeShow(item,index)"
          />
        </van-col>
        <van-col span="24">
          <p>
            <span>商品小计</span>
            {{item.minSum | numFilter}}
          </p>
        </van-col>
        <van-col span="18">
          <p
            v-if="(data.isTmFstNotinAudit || data.isSuBmAudit || data.isWmFstCPAudit) && data.workFlow.workflowType!=1 && data.workFlow.workflowType!=5"
          >
            <van-row>
              <van-field
                v-model="addressPCS[index]"
                readonly
                label="供应商"
                placeholder="请选择供应商"
                @focus="showPop(item.goodsId,item.goods_code,index)"
              />
            </van-row>
          </p>
          <p v-else>
            <span>供应商</span>
            {{supliname[index]}}
          </p>
        </van-col>
        <van-col span="18">
          <van-row v-if="data.isSuBmAudit">
            <van-field
              v-model="rule[index]"
              readonly
              label="同步规则"
              placeholder="请选择同步规则"
              @focus="showRule(item.goodsId,item.goods_code,index)"
            />
          </van-row>
          <!--<p v-if="!data.isSumAudit"><span>同步规则</span>{{item.erporjxc=='1'?'同步进销存':item.erporjxc=='同步进销存'?'同步进销存':item.erporjxc=='2'?'同步ERP':item.erporjxc=='同步ERP'?'同步ERP':''}}</p>-->
        </van-col>
        <van-col span="6" class="text-right pro-edit">
          <!--<p>
                        <van-icon name="edit"/>
                        修改
          </p>-->
        </van-col>
        <van-col span="24">
          <p>
            <span>促销活动</span>
            {{item.pname}}
          </p>
        </van-col>
        <van-col span="24" v-if="data.orders.transport=='物流配送'">
          <p>
            <span>运费单价</span>
            {{item.freight_init}}
          </p>
        </van-col>
        <van-col
          span="24"
          v-if="userRole.indexOf('BM')!=-1 && data.orders.transport=='管车宝'&&workFlow.status==0"
        >
          <van-field
            v-model="cheguanbao[index]"
            label="管车保运费"
            placeholder="请输入管车保运费"
            @blur="getcheguanbao"
          />
        </van-col>
      </van-row>
    </div>
    <van-row v-if="workFlow.workflowType==4|| data.isTmFstNotinAudit || data.isTmSedNotinAudit">
      <van-cell title="实际到货总价" :value="totalGoodPrice  | numFilter" />
    </van-row>
    <van-popup v-model="popShow" position="bottom" :overlay="true">
      <van-picker
        :columns="gys"
        show-toolbar
        value-key="name"
        @cancel="onPickerCancel"
        @confirm="onPickerConfirm"
        @change="onPickerChange"
      />
    </van-popup>

    <van-popup v-model="popRule" position="bottom" :overlay="true">
      <van-picker
        :columns="columnsRule"
        show-toolbar
        value-key="name"
        @cancel="onPickerCancel1"
        @confirm="onPickerConfirm1"
        @change="onPickerChange1"
      />
    </van-popup>

    <!-- 出库编码 -->
    <van-popup v-model="goodcodeshow" position="bottom" :overlay="true">
      <van-picker
        :columns="goodcodecolumns"
        show-toolbar
        @cancel="goodcodeCancel"
        @confirm="goodcodeConfirm"
        @change="goodcodeChange"
      />
    </van-popup>
  </div>
</template>
<script>
import {
  NavBar,
  Cell,
  CellGroup,
  Field,
  Button,
  Row,
  Col,
  Collapse,
  CollapseItem,
  Tabs,
  Tab,
  Switch,
  Picker,
  Popup,
  Checkbox,
  CheckboxGroup,
  Dialog
} from "vant";

export default {
  name: "ApprovalDetail",
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Dialog.name]: Dialog,
    [NavBar.name]: NavBar,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Switch.name]: Switch
  },
  data() {
    return {
      userRole: localStorage.getItem("userRole"),
      activeNames: ["1"],
      checked: true,
      tabActive: 0,
      isOpen1: false,
      openText1: "展开",
      openIcon1: "arrow-down",
      orderInfo: {},
      ordergoods: [],
      ordergoodsdata: [],
      listsup: [],
      curdata: JSON.parse(localStorage.getItem("curdata")),
      popShow: false,
      popRule: false,
      columns: {},
      columnsRule: [
        { id: 1, name: "同步进销存" },
        { id: 2, name: "同步ERP" }
      ],
      addressPCS: [],
      rule: [],
      actionStatus: localStorage.getItem("actionStatus"), //判断是待审批（可编辑）/已审批（不可编辑）
      goodId: 0,
      gys: [],
      supliname: [],
      data: {},
      jm: "",
      isjm: "",
      jmbjg: [],
      jmdata: {},
      gcode: "",
      gindex: 0,
      spcode: [],
      gzcode: "",
      gzindex: 0,
      szpcode: [],
      result: [],
      workFlow: {},
      totalGoodPrice: 0,
      goodcode: [], //出库编码部分
      goodcodecolumns: [],
      goodcodeshow: false,
      goodcodeindex: 0,
      cheguanbao: [],
      receivedCount: [],
      daohuoshu: [],
      guanchebao: [],
      priceDiscout: [], //商品价格/价目表价格*折扣价
      isInit: true
    };
  },
  mounted: function() {
    let that = this;
    that.getinit();
    //setInterval(this.getjmb, 1000);
    //setInterval(this.getjmb(), 10)
  },
  props: {
    jamubiao: null,
    jmb: null
  },
  watch: {
    jamubiao: {
      immediate: true, // 这句重要
      handler(val) {
        let that = this;
        that.getinit();
      }
    },
    jmb: {
      immediate: true, // 这句重要
      handler(val) {
        let that = this;
        that.getinit();
      }
    }
  },
  methods: {
    getresult() {
      let that = this;
      localStorage.setItem("resultCheck", JSON.stringify(that.result));
    },
    getinit() {
      let that = this;
      var orderid = localStorage.getItem("workflow_id");
      /*this.$api.post(that.jumuc.userCenter.selAuditedDetailInfo,
                    {'workFlowId': orderid, 'flag': true},
                    successRes => {
                        that.workFlow = successRes.data.workFlow
                        that.data = successRes.data
                        that.ordergoods = successRes.data.orderGoods
                        that.ordergoodsdata = successRes.data.orderGoods

                        //同步规则
                        /!* if (that.ordergoods.erporjxc == null) {
                             that.columnsRule = []
                         }*!/
                        //供应商
                        var len = that.ordergoods.length;
                        for (let i = 0; i < len; i++) {
                            let goods = that.ordergoods[i];
                            //出库编码初始化
                            that.goodcode[i]=goods.goods_code.split(',')[0]

                            if(goods.parent_cart_id==null||goods.parent_cart_id==''){
                                that.cheguanbao[i]=goods.freight/goods.count
                            }else{
                                that.cheguanbao[i]=0
                            }

                            let listup = goods.listsup
                            let lis = []
                            for (var j = 0; j < listup.length; j++) {
                                if (that.ordergoods[i].suppler_id == listup[j].id) {
                                    that.supliname[i] = listup[j].dictdataValue
                                }
                                if (that.ordergoods[i].suppler_id == null) {
                                    that.supliname[i] = listup[0].dictdataValue
                                }
                                let json = {'id': listup[j].id, 'name': listup[j].dictdataValue}
                                lis.push(json)
                            }
                            that.columns[that.ordergoods[i].goodsId] = lis
                            that.goodcode[i] = goods.goods_code.split(',')[0]
                            that.addressPCS[i] = lis[0].name
                            that.spcode[i] = this.goodcode[i] + '-' + lis[0].id
                            localStorage.setItem("goodgys", JSON.stringify(that.spcode));
                            //columnsRul
                            that.rule[i] = that.columnsRule[0].name;
                            let json = {}
                            json['id'] = that.columnsRule[0].id
                            json['code'] = this.goodcode[i]
                            that.szpcode[i] = json
                            localStorage.setItem("goodRule", JSON.stringify(that.szpcode));
                            //到货数量
                            let jsons = {}
                            jsons['name'] = 'receivedCount_' + goods.cart_id
                            jsons['value'] = goods.receivedCount
                            that.daohuoshu[i] = jsons
                            that.receivedCount[i] = goods.receivedCount
                        }
                        that.getjmb()
                        that.$emit('outGoodCode', that.goodcode)
                        localStorage.setItem("cheguanbao", JSON.stringify(that.guanchebao));
                    })*/
      if (JSON.parse(localStorage.getItem("approvalData")) == null) {
        that.data = {};
        return false;
      } else {
        that.data = JSON.parse(localStorage.getItem("approvalData"));
      }
      that.workFlow = that.data.workFlow;
      that.ordergoods = that.data.orderGoods;
      that.ordergoodsdata = that.data.orderGoods;

      //同步规则
      /* if (that.ordergoods.erporjxc == null) {
                     that.columnsRule = []
                 }*/
      //供应商
      if (that.isInit) {
        var len = that.ordergoods.length;
        for (let i = 0; i < len; i++) {
          let goods = that.ordergoods[i];

          //出库编码初始化
          that.goodcode[i] = goods.goods_code.split(",")[0];

          if (goods.parent_cart_id == null || goods.parent_cart_id == "") {
            that.cheguanbao[i] = goods.freight / goods.received_count;
          } else {
            that.cheguanbao[i] = 0;
          }
           let listup = [];
            let lis = [];
         if(this.workFlow.workflowType==10){
            listup = goods.contractList;
            for (var j = 0; j < listup.length; j++) {
              if (that.ordergoods[i].suppler_id == listup[j]["supplierManage"].id) {
                that.supliname[i] = listup[j]["supplierManage"].code;
              }
              if (that.ordergoods[i].suppler_id == null) {
                that.supliname[i] = listup[0]["supplierManage"].code;
              }
              let json = { id: listup[j]["supplierManage"].id, name: listup[j]["supplierManage"].id };
              lis.push(json);
            }

         }else{
             listup = goods.listsup;
            for (var j = 0; j < listup.length; j++) {
              if (that.ordergoods[i].suppler_id == listup[j].id) {
                that.supliname[i] = listup[j].dictdataValue;
              }
              if (that.ordergoods[i].suppler_id == null) {
                that.supliname[i] = listup[0].dictdataValue;
              }
              let json = { id: listup[j].id, name: listup[j].dictdataValue };
              lis.push(json);
            }
         }
          
          that.columns[that.ordergoods[i].goodsId] = lis;
          that.goodcode[i] = goods.goods_code.split(",")[0];
          that.addressPCS[i] = lis[0].name;
          that.spcode[i] = this.goodcode[i] + "-" + lis[0].id;
          localStorage.setItem("goodgys", JSON.stringify(that.spcode));
          //columnsRul
          let ruleindex = 0;
          if (
            that.ordergoods[i].erporjxc == 1 ||
            that.ordergoods[i].erporjxc == 2
          ) {
            ruleindex = that.ordergoods[i].erporjxc - 1;
          }
          that.rule[i] = that.columnsRule[ruleindex].name;
          let json = {};
          json["id"] = that.columnsRule[ruleindex].id;
          json["code"] = this.goodcode[i];
          that.szpcode[i] = json;
          localStorage.setItem("goodRule", JSON.stringify(that.szpcode));
          //到货数量
          let jsons = {};
          jsons["name"] = "receivedCount_" + goods.cart_id;
          jsons["value"] = goods.receivedCount;
          that.daohuoshu[i] = jsons;
          that.receivedCount[i] = goods.receivedCount;
        }
        that.isInit = false;
        that.$emit("outGoodCode", that.goodcode);
        localStorage.setItem("cheguanbao", JSON.stringify(that.guanchebao));
      }
      that.getjmb();
    },
    getreceivedCount() {
      let that = this;
      var len = that.ordergoods.length;
      let isReceivedCount = 0;
      var sumPrice = 0;
      for (let i = 0; i < len; i++) {
        let jsons = {};
        jsons["name"] = "receivedCount_" + that.ordergoods[i].cart_id;
        jsons["value"] = that.receivedCount[i];
        that.daohuoshu[i] = jsons;
        if (that.ordergoods[i].receivedCount != that.receivedCount[i]) {
          isReceivedCount = 1;
        }
        let good = that.ordergoods[i];
        let freight = good.freight == null ? 0 : good.freight;
        //折扣
        let discount = good.discount == null ? 1 : good.discount;
        let pay_discount = good.pay_discount == null ? 1 : good.pay_discount;
        if (good.parent_cart_id == null || good.parent_cart_id == "") {
          //that.sumPrice = that.sumPrice + good.price * good.received_count * discount * pay_discount + good.received_count * (freight / good.count)
          sumPrice =
            sumPrice +
            that.priceDiscout[i] * that.receivedCount[i] +
            that.receivedCount[i] * (freight / good.received_count);
        } else {
          sumPrice = sumPrice + 0;
        }
      }
      localStorage.setItem("sumPrice", sumPrice);
      that.$emit("sumPrice", sumPrice);
      localStorage.setItem("isReceivedCount", isReceivedCount);
      localStorage.setItem("receivedCount", JSON.stringify(that.daohuoshu));
    },
    getcheguanbao() {
      let that = this;
      let goodsCartArr = [];
      var len = that.ordergoods.length;
      for (let i = 0; i < len; i++) {
        let jsons = {};
        jsons["name"] = that.ordergoods[i].cart_id;
        jsons["shipPrice"] = that.cheguanbao[i];
        that.guanchebao[i] = jsons;

        let gcb = {};
        gcb["goodsCartId"] = that.ordergoods[i].cart_id;
        gcb["shipPriceValue"] = that.cheguanbao[i];
        goodsCartArr[i] = gcb;
      }
      //cheguanbao
      var sumPrice = 0;
      for (var n = 0; n < that.cheguanbao.length; n++) {
        if (that.cheguanbao[n] != "") {
          //折扣
          let payDiscount =
            that.ordergoods[n].pay_discount == null
              ? 1
              : that.ordergoods[n].pay_discount;
          let discounts =
            that.ordergoods[n].discount == null
              ? 1
              : that.ordergoods[n].discount;
          sumPrice =
            sumPrice +
            parseFloat(that.cheguanbao[n]) *
              that.ordergoods[n].received_count *
              payDiscount *
              discounts; //运费
          sumPrice =
            sumPrice +
            that.ordergoods[n].received_count *
              that.priceDiscout[n] *
              payDiscount *
              discounts;
        }
      }
      localStorage.setItem("sumPrice", sumPrice);
      that.$emit("sumPrice", sumPrice);
      localStorage.setItem("cheguanbao", JSON.stringify(that.guanchebao));
      localStorage.setItem("goodsCartArr", JSON.stringify(goodsCartArr));
    },
    getjmb() {
      let that = this;
      localStorage.setItem("resultCheck", JSON.stringify(that.result));
      if (
        localStorage.getItem("isjmbid") == "true" ||
        that.data.hasErpPrice == 0
      ) {
        /* if (that.jm != localStorage.getItem('jmbid')) {
                         that.jm = localStorage.getItem('jmbid')*/
        let goodsId = [];
        let json = {};
        let goodsCode = "";
        let code = [];
        for (var i = 0; i < that.ordergoodsdata.length; i++) {
          json["goodsId"] = that.goodcode[i];
          json["unit_zhxs"] = that.ordergoodsdata[i].unit_zhxs;
          goodsId[i] = json;
          goodsCode = goodsCode + that.goodcode[i] + ",";
          code[i] = that.goodcode[i];
        }
        //erp信息-获取价目表价格
        that.$api.post(
          that.jumuc.userCenter.getGoodsPriceByPriceListIdAndGoodsId,
          {
            priceId: localStorage.getItem("jmbid"),
            goodsId: JSON.stringify(goodsId),
            goodsCode: goodsCode
          },
          successRes => {
            let data = JSON.parse(successRes.data).data;
            let i = 0;
            that.ordergoods = [];
            that.jmdata = data;
            let str = "";
            for (var key in data) {
              str = str + key + "-" + data[key] + ",";
              if (key == code[i]) {
                that.jmbjg[i] = data[key];
                i++;
              }
              if (localStorage.getItem("isjmbid") == "true") {
                for (var k = 0; k < that.data.orderGoods.length; k++) {
                  let good = that.data.orderGoods[k];
                  if (k == that.ordergoods.length - 1) {
                    that.ordergoods[k] = good;
                  }
                  if (good.goods_code == key) {
                    good.minSum = data[key] * good.received_count;
                    that.ordergoods[k] = good;
                  }
                }
              } else {
                that.ordergoods = that.data.orderGoods;
              }
            }
            if (str != "") {
              str = str.substring(0, str.length - 1);
              localStorage.setItem("goodjg", str);
            }

            var codes = "";

            for (var j = 0; j < code.length; j++) {
              if (data[code[j]] == null || data[code[j]] == "") {
                codes += code + " ";
              }
            }

            if (codes.length > 1) {
              Dialog.alert({
                title: "",
                message: codes
              }).then(() => {
                // on close
              });
            }

            data = that.jmdata;
            for (var key in data) {
              for (var k = 0; k < that.data.orderGoods.length; k++) {
                let good = that.data.orderGoods[k];
                if (k == that.ordergoods.length - 1) {
                  that.ordergoods[k] = good;
                }
                if (good.goods_code == key) {
                  //计算折扣价
                  let pay_discount =
                    good.pay_discount == null ? 1 : good.pay_discount;
                  let discount = good.discount == null ? 1 : good.discount;
                  good.minSum = 0;
                  good.minSum =
                    data[key] * pay_discount * discount * good.received_count;
                  that.ordergoods[k] = good;
                  that.priceDiscout[k] = data[key];
                }
              }
            }
            let sumPrice = 0;
            //计算本次订单扣款金额
            for (var n = 0; n < that.ordergoods.length; n++) {
              sumPrice = sumPrice + that.ordergoods[n].minSum;
            }
            //cheguanbao
            for (var n = 0; n < that.cheguanbao.length; n++) {
              sumPrice =
                sumPrice +
                parseFloat(that.cheguanbao[n]) *
                  that.ordergoods[n].received_count;
            }
            that.totalGoodPrice = sumPrice;
            localStorage.setItem("sumPrice", sumPrice);
            that.$emit("sumPrice", sumPrice);
          }
        );
      } else {
        that.jmbjg = [];
        that.ordergoods = [];
        for (var k = 0; k < that.data.orderGoods.length; k++) {
          let good = that.data.orderGoods[k];
          /*good.minSum = good.price * good.shipment_count*/
          let payDiscount = 1;
          let discounts = 1;
          that.data.orderGoods[k]["minSum"] =
            that.data.orderGoods[k].price *
            that.data.orderGoods[k].received_count *
            payDiscount *
            discounts;
          that.ordergoods[k] = that.data.orderGoods[k];
          that.priceDiscout[k] = that.data.orderGoods[k].price;
          //Vue.set(that.ordergood,k, that.data.orderGoods[k])
        }

        /* }*/
        let sumPrice = 0;
        //计算本次订单扣款金额
        for (var n = 0; n < that.ordergoods.length; n++) {
          sumPrice = sumPrice + that.ordergoods[n].minSum;
        }
        console.log(sumPrice);
        //cheguanbao
        for (var n = 0; n < that.cheguanbao.length; n++) {
          sumPrice =
            sumPrice +
            parseFloat(that.cheguanbao[n]) * that.ordergoods[n].received_count;
        }
        that.totalGoodPrice = sumPrice;
        localStorage.setItem("sumPrice", sumPrice);
        that.$emit("sumPrice", sumPrice);
      }
    },
    showPop(id, goods_code, index) {
      let that = this;
      that.goodId = id;
      let i = 0;
      for (var key in that.columns) {
        if (key == id) {
          that.gys = that.columns[key];
        }
        /* if(i==0){
                         that.addressPCS[0]=that.gys[0].name
                         this.spcode[0]=this.gcode+'-'+that.gys[0].id
                     }*/
      }
      that.gcode = goods_code;
      that.gindex = index;
      that.popShow = true;
    },
    showRule(id, goods_code, index) {
      this.goodId = id;
      this.gzcode = goods_code;
      this.gzindex = index;
      this.popRule = true;
    },
    onPickerCancel() {
      this.popShow = false;
    },
    onPickerConfirm(values) {
      this.addressPCS[this.gindex] = values.name;
      this.spcode[this.gindex] = this.goodcode[this.gindex] + "-" + values.id;

      localStorage.setItem("goodgys", JSON.stringify(this.spcode));
      this.popShow = false;
    },
    onPickerChange(picker, values) {
      picker.setColumnValues(1, values.name);
    },
    onPickerCancel1() {
      this.popRule = false;
    },
    onPickerConfirm1(values) {
      this.rule[this.gzindex] = values.name;
      let json = {};
      json["id"] = values.id;
      json["code"] = this.goodcode[this.gzindex];
      this.szpcode[this.gzindex] = json;
      localStorage.setItem("goodRule", JSON.stringify(this.szpcode));
      this.popRule = false;
    },
    onPickerChange1(picker, values) {
      picker.setColumnValues(1, values.name);
    },
    back() {
      history.back();
    },
    showOpen1(i) {
      this.isOpen1 = !this.isOpen1;
      this.openText1 = this.isOpen1 ? "收起" : "展开";
      this.openIcon1 = this.isOpen1 ? "arrow-up" : "arrow-down";
    } /*,priceswitch(checked){
                this.checked=checked
                localStorage.setItem("priceswitch", checked);
            }*/,
    showKuCunC(item) {
      //成品查看库存
      this.$router.push({
        path: "/stock/stocklistc",
        query: {
          goodsId: item.goodsId,
          goodsCode: item.goods_code,
          organizationId: item.organizationId,
          orderId: this.data.orders.id
        }
      });
    },

    showKuCun(item) {
      //奶牛查看库存
      this.$router.push({
        path: "/stock/stocklist",
        query: {
          goodsId: item.goodsId,
          goodsCode: item.goods_code,
          unit_zhxs: item.unit_zhxs
        }
      });
    },
    goodcodeShow(item, index) {
      //选择业务编码部分
      let that = this;
      that.goodcodeindex = index;
      that.goodcodecolumns = item.goods_code.split(",");
      that.goodcodeshow = true;
    },
    goodcodeCancel() {
      let that = this;
      that.goodcodeshow = false;
    },
    goodcodeConfirm(values) {
      let that = this;
      that.goodcode[that.goodcodeindex] = values;
      that.$emit("outGoodCode", that.goodcode);
      that.goodcodeshow = false;
    },
    goodcodeChange(picker, values) {
      picker.setColumnValues(1, values);
    }
  },
  filters: {
    numFilter(value) {
      // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(2);
      return realVal;
    }
  }
};
</script>
<style lang="less">
@bule-thame: #3c6eeb;

body {
  background: #f7f7ff;
}

#app .van-tabs__line {
  height: 45px;
  background-color: rgba(255, 255, 255, 0.1);
  min-width: 80px;
  left: -10px;
}

.appr-tabs {
  .van-tab {
    color: #fff;
  }
  .van-tabs__nav {
    background-color: @bule-thame;
  }
  .van-hairline--top-bottom::after {
    border-width: 0;
  }
}

.jump-warphd {
  /*.van-icon {
            color: @bule-thame;
        }*/
  .appr-item {
    padding: 10px;
    margin-bottom: 10px;
    background-color: #fff;
    h5 {
      font-size: 16px;
      padding-bottom: 10px;
      i {
        padding: 5px;
        background-color: @bule-thame;
        color: #fff;
        border-radius: 100%;
        margin-right: 5px;
      }
    }
    p {
      padding: 4px 0;
      font-size: 14px;
      &.item-r {
        color: #ccc;
        text-align: right;
      }
      span {
        min-width: 60px;
        display: inline-block;
        margin-right: 5px;
      }
    }
    &-head {
      border-bottom: 1px #f7f7f7 solid;
      &-hd {
        position: relative;
      }
    }
    &-foot {
      border-top: 1px #f7f7f7 solid;
      p {
        color: #ccc;
      }
    }
    .item-arrow {
      border-top: 1px solid #f7f7f7;
      text-align: center;
      color: @bule-thame;
    }
    .line {
      display: block;
      border-bottom: 1px solid #f7f7f7;
    }
  }

  .pro-body {
    padding: 10px;
    color: #2c3e50 !important;
    .pro-item {
      margin-bottom: 10px;
      background-color: #fff;
      padding: 10px;
      h5 {
        font-size: 14px;
        padding-bottom: 10px;
        border-bottom: 1px solid #f7f7f7;
      }
      span {
        min-width: 60px;
        display: inline-block;
        margin-right: 5px;
      }
      p {
        font-size: 14px;
        padding: 10px 0;
      }
      &-by {
        padding: 10px 0 0;
      }
      &-ft {
        background-color: #f7f7f7;
        padding: 10px;
        .van-cell {
          background: none;
          padding-left: 0;
        }
      }
      .pro-edit {
        color: @bule-thame;
        text-decoration: underline;
        i {
          vertical-align: -2px;
        }
      }
    }
  }
  .pay-by {
    padding: 10px;
    .pay-item {
      background-color: #fff;
      padding: 10px;
      position: relative;
      margin-bottom: 10px;
      p {
        color: #ccc;
        font-size: 12px;
        padding: 5px 0;
      }
      &-ft {
        padding-top: 10px;
        p {
          color: #333;
        }
      }
      .pay-state {
        text-align: right;
        color: @bule-thame;
        i {
          display: inline-block;
          padding: 5px;
          border-radius: 100%;
          background-color: @bule-thame;
        }
      }
      &-rd {
        position: absolute;
        top: 0;
        left: -5px;
        width: 10px;
        height: 100%;
        background-color: @bule-thame;
        border-radius: 10px 0 0 10px;
      }

      &.ok {
        .pay-state {
          color: #28a745;
          i {
            background-color: #28a745;
          }
        }
        .pay-item-rd {
          background-color: #28a745;
        }
      }
      &.err {
        .pay-state {
          color: #ffc107;
          i {
            background-color: #ffc107;
          }
        }
        .pay-item-rd {
          background-color: #ffc107;
        }
      }
    }
  }
  .pay-hd-item {
    margin-bottom: 10px;
    .pay-hd-line {
      border-bottom: 1px solid #f7f7f7;
      margin-bottom: 10px;
    }
    .van-field {
      border: 1px solid #f7f7f7;
    }
  }

  .van-cell:not(:last-child)::after {
    border: none;
  }

  .apply {
    .van-field {
      margin: 10px 0;
      border: 1px solid #f7f7f7;
    }
    .van-col--8 {
      padding: 0 10px;
    }
    button {
      font-size: 14px;
      height: 40px;
      line-height: 38px;
      background-color: @bule-thame;
      border-color: @bule-thame;
    }
    button.danger {
      background-color: #ffc107;
      border-color: #ffc107;
    }
  }

  .item-body-warp {
    height: 60px;
    overflow: hidden;
    position: relative;
  }
  .item-body-warp.open {
    height: auto;
  }
}
</style>
